import React from 'react';
import { styled } from '@linaria/react';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { ProviderLogo } from '@daedalus/shared/src/search/ProviderLogo';
type PropsType = {
  providerCode: string;
};
const Message = /*#__PURE__*/styled('div')({
  name: "Message",
  class: "m1zfa3z",
  propsAsIs: false
});
const RedirectMessage = ({
  providerCode
}: PropsType) => {
  return <Message>
      <FormattedMessageWrapper id="providerRedirect.transferMessage" defaultMessage="Transferring you to<br></br>{logo}<br></br>to complete your booking" values={{
      logo: <>
              <ProviderLogo variant="logo" height={30} providerCode={providerCode} />
            </>,
      br: () => <br />
    }} />
    </Message>;
};
export default RedirectMessage;

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");